<template>
  <div class="popup-course-row">
    <DifficultyIcon :difficulty="course.difficulty" />
    <div>
      <h3>{{ course.name }}</h3>
      <p>{{ course.description }}</p>
      <nuxt-link :to="`/courses/${course.id}`">Course Details</nuxt-link>
      <IfLoggedIn>
        <Spinner v-if="loading" />
        <Button v-else-if="!hidePreview" link @click="preview"
          >Preview Course</Button
        >
      </IfLoggedIn>
    </div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{
  hidePreview?: boolean;
  course: {
    id: string;
    name: string;
    description: string;
    difficulty: string;
    estimated_duration_hours: number;
  };
}>();

const client = useClient();
const loading = ref(false);
const emit = defineEmits({
  preview: (course: CourseForView) => true,
});

async function preview() {
  try {
    loading.value = true;
    const course = await expectData(getCourseForView(client, props.course.id));

    exists(course);
    emit("preview", course);
  } catch (x) {
    alert("error fetching course: " + x);
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.popup-course-row {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: var(--quarter-grid);
  align-items: center;
}

.popup-course-row:not(:first-child) {
  margin-top: 0.5em;
  border-top: 1px solid gray;
  padding-top: 0.5em;
}

a {
  text-decoration: underline;
}

button {
  text-decoration: underline;
}
</style>
